import { memo, useEffect } from 'react'
import ThemeProvider from 'ThemeProvider'
import Typography from '@material-ui/core/Typography'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { trackInAmplitude } from '../utils/tracking/amplitude'
import { AmplitudeEvent } from '../utils/tracking/amplitude/amplitude.interface'

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      margin: theme.spacing(4),
      textAlign: 'center'
    }
  })
)

const ErrorFallback = () => {
  const { container } = useStyles()

  useEffect(() => {
    trackInAmplitude(AmplitudeEvent.ErrorPageShown)
  }, [])

  return (
    <ThemeProvider>
      <div className={container}>
        <Typography component="p" variant="h1">
          <span role="img" aria-label="worried face">
            😟
          </span>
        </Typography>
        <Typography component="p" variant="h3">
          Entschuldigung, da ist etwas schief gelaufen.
        </Typography>
        <Typography component="p" variant="h2">
          Wir arbeiten daran!
        </Typography>
      </div>
    </ThemeProvider>
  )
}

export default memo(ErrorFallback)
